export default "__VITE_ASSET__Df14a5w8__"